import React, { memo } from 'react';
import { ColorTokens, IconTokens, FontFamilyTokens, SizeTypeTokens, BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, IconAlignmentTokens, } from '@voltmoney/schema';
import { View } from 'react-native';
import Typography from '../typography/Typography';
import Space from '../space/Space';
import Card from '../card/Card';
import Button from '../button/Button';
import ThemeProvider from '@voltmoney/theme';
/**
 * Primary UI component for user interaction
 */
const SuggestionCard = ({ title, subTitle, actionText, quotationText, quotationSubText, ctaText, action, triggerAction, actionSecondary, isMore = false, }) => {
    const theme = ThemeProvider.getTheme();
    const colorMap = theme.colors;
    return (React.createElement(View, { style: {
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: colorMap[ColorTokens.Primary_10],
            backgroundColor: colorMap[ColorTokens.White],
            padding: 16,
        } },
        React.createElement(View, { style: {
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
            } },
            React.createElement(View, { style: {
                    flexDirection: 'column',
                } },
                React.createElement(Typography, { ...title }),
                React.createElement(Space, { size: SizeTypeTokens.SM }),
                React.createElement(Typography, { ...subTitle })),
            React.createElement(Button, { type: ButtonTypeTokens.MediumSoftFilled, width: ButtonWidthTypeToken.CONTENT, label: actionText, labelColor: ColorTokens.Primary_100, action: actionSecondary, triggerAction: triggerAction })),
        isMore && React.createElement(Space, { size: SizeTypeTokens.XL }),
        isMore && (React.createElement(Card, { bgColor: ColorTokens.Secondary_05, borderRadius: BorderRadiusTokens.BR3, padding: {
                vertical: SizeTypeTokens.LG,
                horizontal: SizeTypeTokens.LG,
            }, body: {
                children: [
                    React.createElement(React.Fragment, null,
                        React.createElement(Typography, { ...quotationText }),
                        React.createElement(Space, { size: SizeTypeTokens.XS }),
                        React.createElement(Typography, { ...quotationSubText }),
                        React.createElement(Space, { size: SizeTypeTokens.LG }),
                        React.createElement(Button, { type: ButtonTypeTokens.SmallGhost, width: ButtonWidthTypeToken.CONTENT, label: ctaText, fontFamily: FontFamilyTokens.Inter, labelColor: ColorTokens.Primary_100, action: action, triggerAction: triggerAction, icon: {
                                name: IconTokens.ChervonDownRight,
                                align: IconAlignmentTokens.right,
                            } })),
                ],
            } }))));
};
export default memo(SuggestionCard);
export { SuggestionCard };
